export default __webpack_public_path__ + "static/our-mission-shape1-42a0525040b7051385b89e072d6cbf5a.png";